import React, { useCallback, useMemo } from 'react'
import { inject, observer } from 'mobx-react'
import { Tab, TabContent, Tabs } from 'react-bootstrap'
import styled, { withTheme } from 'styled-components'
import OrdersList from './OrdersList'
import { withTranslation } from 'react-i18next'
import getThemeValue from '../../utils/getThemeValue'
import { cloneDeep } from 'lodash'
import withRouter from '../../utils/withRouter'

const StyledTabs = styled.div`
  margin-bottom: 20px;

  .nav-item,
  .nav-item.nav-link.disabled {
    display: inline-block;
    border-color: #dee2e6;
    margin-top: 30px;
    margin-left: 2px;
    margin-right: 2px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  @media screen and (max-width: 600px) {
    .nav-item,
    .nav-item.nav-link.disabled {
      margin-top: 10px;
    }
  }
`

const OrdersTabs = observer(({ ordersStore, t, location, navigate }) => {
  const handleSelect = useCallback(
    (key) => {
      const newState = location.state ? cloneDeep(location.state) : {}
      newState.selectedStatus = key

      const pathname = ordersStore.targetBusinessPartnerId
        ? `/employee-orders/${ordersStore.targetBusinessPartnerId}`
        : '/orders'

      navigate(pathname, { state: newState })
    },
    [location.state, navigate, ordersStore.targetBusinessPartnerId]
  )

  const getTabTitle = useCallback(
    (apiObj) => {
      let title = ''

      switch (apiObj.status) {
        case 'open':
          title = t('orders:tabOpen')
          break
        case 'closed':
          title = t('orders:tabClosed')
          break
        case 'cancelled':
          title = t('orders:tabCancelled')
          break
        case 'openApprovals':
          title = t('orders:openApprovalsOrders')
          break
        case 'openTransmissionsSRM':
          title = t('orders:openTransmissionsSRMOrders')
          break
        case 'openApprovalsSRM':
          title = getThemeValue(
            'ordersTabs',
            'ordersTabHeader',
            t('orders:openApprovalsSRMOrders')
          )
          break
        default:
          title = apiObj.status
      }

      return `${title}${apiObj.count ? ` (${apiObj.count})` : ''}`
    },
    [t]
  )

  const tabs = useMemo(() => {
    return (
      <Tabs
        activeKey={ordersStore.selectedStatus}
        onSelect={handleSelect}
        unmountOnExit
      >
        {ordersStore.incomingOrdersCounter
          .filter((apiObj) => apiObj.count)
          .map((apiObj) => (
            <Tab
              key={apiObj.status}
              eventKey={apiObj.status}
              title={getTabTitle(apiObj)}
            />
          ))}
      </Tabs>
    )
  }, [
    ordersStore.selectedStatus,
    ordersStore.incomingOrdersCounter,
    handleSelect,
    getTabTitle,
  ])
  return (
    <StyledTabs>
      {tabs}
      <TabContent>
        <OrdersList />
      </TabContent>
    </StyledTabs>
  )
})

export default withTheme(
  withTranslation()(withRouter(inject('ordersStore')(OrdersTabs)))
)
